import React, { useState } from "react";
import { Button, FlexContainer, LottieLoadingIndicator, StandardModal, StandardModalActionGroup, Toast } from "src/components";
import { ActionButton, TextLabel } from "./style";
import Desktop from "src/img/emailCampaigns/desktop.svg";
import Mobile from "src/img/emailCampaigns/mobile.svg";
import Document from "src/img/emailCampaigns/document@2x.png";
import { PREVIEW_TYPE, SIDEBAR_LIST } from "../constants";
import Footer from "./new/rightContainer/Footer";
import { LoadingIndicatorButton } from "src/scenes/Survey/components/Utils";
import { duplicateEmail } from "../api/emailCampaignsApi";

export default function DuplicateDialog(props) {
    const {
        campaignUuid,
        emailSubject = "",
        headerImageUrl = "",
        emailContent = "",
        toggleModal,
        attachments = [],
        setSelectedAction,
        setCurrentSidebar
    } = props;
    const [preview, setPreview] = useState(PREVIEW_TYPE.DESKTOP);
    const [isLoading, setIsLoading] = useState(false);

    const closeModal = () => {
        toggleModal();
        setSelectedAction({});
    };

    const attachmentType = (filename, s3Url) => {
        const ext = filename.split(".").pop().toLowerCase();

        const documentExtensions = [
            "pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx",
            "txt", "csv", "rtf"
        ];

        if (documentExtensions.includes(ext)) return Document;

        return s3Url;
    };

    const onDuplicateEmail = async () => {
        setIsLoading(true);
        try {
            const response = await duplicateEmail(campaignUuid);
            if (response) {
                Toast.info("Email campaign duplicated successfully.");
                setCurrentSidebar(SIDEBAR_LIST.DRAFT);
                toggleModal();
                setSelectedAction({});
            }
        } catch (error) {
            console.log("Error: ", error);
            Toast.error("Error occurred while duplicating email campaign.");
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <StandardModal
            open={true}
            onClose={closeModal}
            widthMode="table"
            title="Duplicate Email Campaign"
            description="Review the campaign preview before creating a duplicate draft."
            footer={(
                <StandardModalActionGroup $pushRight>
                    <Button
                        type="button"
                        onClick={closeModal}
                        width="140px"
                        height="38px"
                        border="1px solid #000"
                        color="#000000"
                        style={{ borderRadius: "7px", boxShadow: "none" }}
                    >
                        Cancel
                    </Button>
                    {isLoading ? (
                        <LoadingIndicatorButton>
                            <LottieLoadingIndicator
                                height="2rem"
                                width="2rem"
                                margin="5px"
                                containerHeight="2rem"
                            />
                        </LoadingIndicatorButton>
                    ) : (
                        <Button
                            type="button"
                            onClick={() => onDuplicateEmail()}
                            width="140px"
                            height="38px"
                            backgroundColor="#171A22"
                            border="1px solid #171A22"
                            color="#FFFFFF"
                            style={{ borderRadius: "7px", boxShadow: "none" }}
                        >
                            Duplicate
                        </Button>
                    )}
                </StandardModalActionGroup>
            )}
        >
            <FlexContainer width="100%">
                <FlexContainer
                    gap="10px"
                    width="100%"
                    alignItems="center"
                    style={{
                        position: "relative",
                        width: preview === PREVIEW_TYPE.MOBILE ? "479px" : "100%",
                    }}
                >
                    <FlexContainer
                        height="96px"
                        color="#FFFFFF"
                        borderRadius="20px"
                        border="1px solid #D8DEEC"
                        direction="row"
                        tDirection="row"
                        justifyContent="space-between"
                        alignItems="center"
                        padding="0 2rem"
                        width="100%"
                        overflowX="auto"
                        style={{
                            position: "relative",
                            width: preview === PREVIEW_TYPE.MOBILE ? "479px" : "100%",
                        }}
                    >
                    Preview
                        <FlexContainer direction="row" gap="20px" tDirection="row">
                            <ActionButton
                                width={preview === PREVIEW_TYPE.DESKTOP ? "174px" : "150px"}
                                height="50px"
                                color="#000000"
                                backgroundColor={
                                    preview === PREVIEW_TYPE.DESKTOP
                                        ? "rgba(91, 110, 245, 0.12) 0% 0% no-repeat padding-box"
                                        : "#FFFFFF 0% 0% no-repeat padding-box"
                                }
                                border="1px solid #D8DEEC"
                                style={{ gap: "10px" }}
                                onClick={() => setPreview(PREVIEW_TYPE.DESKTOP)}
                            >
                                <img src={Desktop} width="19" height="19" /> Desktop
                            </ActionButton>
                            <ActionButton
                                width={preview === PREVIEW_TYPE.DESKTOP ? "174px" : "150px"}
                                height="50px"
                                color="#000000"
                                backgroundColor={
                                    preview === PREVIEW_TYPE.MOBILE
                                        ? "rgba(91, 110, 245, 0.12) 0% 0% no-repeat padding-box"
                                        : "#FFFFFF 0% 0% no-repeat padding-box"
                                }
                                border="1px solid #D8DEEC"
                                style={{ gap: "10px" }}
                                onClick={() => setPreview(PREVIEW_TYPE.MOBILE)}
                            >
                                <img src={Mobile} width="19" height="19" /> Mobile
                            </ActionButton>
                        </FlexContainer>
                    </FlexContainer>
                    <FlexContainer
                        height="1089px"
                        color="#FFFFFF"
                        borderRadius="20px"
                        border="1px solid #D8DEEC"
                        // justifyContent="space-between"
                        style={{
                            position: "relative",
                            width: preview === PREVIEW_TYPE.MOBILE ? "479px" : "100%",
                        }}
                    >
                        <div
                            style={{
                                borderBottom: "1px solid #D8DEEC",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                height: "68px",
                                width: "100%",
                                bottom: "0px",
                                left: "0px",
                            }}
                        >
                            <FlexContainer padding="0 2rem">
                                {emailSubject ? (
                                    <FlexContainer
                                        direction="row"
                                        tDirection="row"
                                        justifyContent="center"
                                    >
                                        <TextLabel
                                            marginBottom="0px"
                                            fontWeight="bold"
                                            style={{
                                                marginLeft:
                                                preview === PREVIEW_TYPE.DESKTOP ? "70px" : "0px",
                                            }}
                                        >
                                        Subject:
                                        </TextLabel>
                                        <TextLabel marginBottom="0px" style={{ marginLeft: "5px" }}>
                                            {emailSubject}
                                        </TextLabel>
                                    </FlexContainer>
                                ) : (
                                    <TextLabel marginBottom="0px">Subject here</TextLabel>
                                )}
                            </FlexContainer>
                        </div>
                        {headerImageUrl && (
                            <FlexContainer
                                width="auto"
                                maxHeight="200px"
                                height="200px"
                                color="#FAFAFA"
                                border="1px solid #D8DEEC"
                                style={{
                                    position: "relative",
                                    boxShadow: "0px 3px 6px #00000029",
                                    backgroundImage: `url(${headerImageUrl})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    marginTop: "30px",
                                    marginLeft: preview === PREVIEW_TYPE.DESKTOP ? "100px" : "30px",
                                    marginRight: preview === PREVIEW_TYPE.DESKTOP ? "100px" : "30px",
                                }}
                            ></FlexContainer>
                        )}
                        <FlexContainer
                            style={{
                                marginLeft: preview === PREVIEW_TYPE.DESKTOP ? "100px" : "30px",
                                marginRight: preview === PREVIEW_TYPE.DESKTOP ? "100px" : "30px",
                                overflow: "auto",
                                height: "800px",
                                marginBottom: "10px",
                                marginTop: "10px",
                            }}
                        >
                            {emailContent && (
                                <div
                                    style={{
                                        fontFamily: "Manrope, sans-serif",
                                        fontWeight: "normal",
                                        width: "100%",
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html: (emailContent),
                                    }}
                                />
                            )}
                        </FlexContainer>
                        <Footer />
                    </FlexContainer>
                    <FlexContainer height="auto" width="100%" direction="row" gap="10px" tDirection="row" wrap="wrap">
                        {attachments.length > 0 && attachments.map((attachment, index) => {
                            return (
                                <FlexContainer key={index} alignItems="center">
                                    <img
                                        src={attachmentType(attachment.filename, attachment.s3Url)}
                                        alt={attachment.filename}
                                        style={{
                                            width: "150px",
                                            height: "84px",
                                            objectFit: "contain"
                                        }}
                                    />
                                    <TextLabel>{attachment.filename}</TextLabel>
                                </FlexContainer>
                            );
                        })}
                    </FlexContainer>
                </FlexContainer>
            </FlexContainer>
        </StandardModal>
    );
}
